import React from 'react'
import { Booklet } from '../../../../types/generated.types'
import { useQuery } from '@apollo/client'
import { getBookletCompaniesCountQuery } from '../../../../queries/booklet'
import BookletDetails from '../../BookletDetails'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

type BookletCardProps = {
  booklet: Booklet
}

const BookletCard: React.FC<BookletCardProps> = ({ booklet }) => {

  // Hämta antal butiker och kuponger
  const { data: countData } = useQuery(getBookletCompaniesCountQuery, { variables: { _id: booklet._id } })

  // Räkna antal butiker och kuponger
  const companyCount = countData?.booklet?.calculatedCompanies?.length || 0
  const couponCount = countData?.booklet?.calculatedCompanies
    ? countData.booklet.calculatedCompanies.reduce((sum: number, company: any) => sum + (company.calculatedCoupons?.length || 0), 0)
    : 0


  return (
    <div className="booklet-card box md">
      <div className="booklet-image">
        {booklet.imageOfSingleBookletInAppURL ? (
          <img src={REACT_APP_IMAGE_BASE_URL + booklet.imageOfSingleBookletInAppURL} alt={booklet.title} />
        ) : (
          <div className="booklet-placeholder" />
        )}
      </div>
      <div className="booklet-info">
        <BookletDetails
          booklet={booklet}
          companyCount={companyCount}
          couponCount={couponCount}
        />
      </div>
    </div>
  )
}

export default BookletCard
